import * as svg from "../../../assets/solid-chevron-down.svg";

import {iconBuilder} from "./iconBuilder";

export const SolidChevronDownIcon = iconBuilder(svg, "SolidChevronDownIcon", "0 0 10 6");
